<script>
export default {
    name: "color-scheme-select",
    components: {},
    data() {
        return {
            options: [
                { id: 2, name: Lang.langGet("Company color scheme (default)") },
                { id: 1, name: Lang.langGet("High contrast color scheme") },
                { id: 0, name: Lang.langGet("Custom colors") },
            ],
            optionSelected: 2
        }
    },
    props: [
        ''
    ],
    computed: {
        translations() {
            return {
                optionLabel: Lang.langGet('Color Scheme'),
                companyColorsOption: Lang.langGet("Company contrast color scheme (default)"),
                highContrastOption: Lang.langGet("High contrast color scheme"),
                customColorsOption: Lang.langGet("Custom colors"),
                mainColorLabel: Lang.langGet("Main color"),
                colorDescription: Lang.langGet("This color should have a high contrast to the main color. For example: Black has a high contrast to white."),
                textColorLabel: Lang.langGet("Text color")
            }
        },
    },
    watch: {},
    methods: {
        handleOptionChange() {
            switch (this.optionSelected) {
                case 1:
                    $("#edit-project form.edit-project input[name='color']").val('#222222');
                    $("#edit-project form.edit-project input[name='textcolor']").val('#ffffff');
                    $("#edit-project form.edit-project input[name='color']").parent().colorpicker("setValue", '#222222');
                    $("#edit-project form.edit-project input[name='textcolor']").parent().colorpicker("setValue", '#ffffff');

                    break;
                case 2:
                    $("#edit-project form.edit-project input[name='color']").val('#203363');
                    $("#edit-project form.edit-project input[name='textcolor']").val('#ffffff');
                    $("#edit-project form.edit-project input[name='color']").parent().colorpicker("setValue", '#203363');
                    $("#edit-project form.edit-project input[name='textcolor']").parent().colorpicker("setValue", '#ffffff');

                    break;
            }

            this.updateColorpickerState();
        },
        updateColorpickerState() {
            const disabled = this.optionSelected !== 0;

            $("#edit-project form.edit-project input[name='color']").parent().colorpicker(disabled ? 'disable' : 'enable');
            $("#edit-project form.edit-project input[name='textcolor']").parent().colorpicker(disabled ? 'disable' : 'enable');
        }
    },
    mounted() {
        this.updateColorpickerState();
    }
}
</script>

<template>
    <div class="d-flex flex-column col-md-12">
        <div class="color-picker-row">
            <div class="form-group">
                <label for="color-select" aria-label="high contrast">
                    {{ translations.optionLabel }}
                    <select
                        v-model="optionSelected"
                        class="form-control"
                        id="color-select"
                        name="color_scheme"
                        aria-label="color scheme select"
                        @change="handleOptionChange"
                        @input="handleOptionChange"
                    >
                        <option v-for="option in options" v-bind:value="option.id">
                            {{ option.name }}
                        </option>
                    </select>
                </label>
            </div>
                <div class="form-group">
                    <label v-bind:class="{ 'text-muted': optionSelected !== 0 }" aria-label="main color" for="color-form-element">
                        {{ translations.mainColorLabel }}
                    </label>
                    <div class="input-group colorpicker-component">
                        <input
                            type="text"
                            name="color"
                            class="form-control"
                            id="color-form-element"
                            aria-label="main color input"
                            :disabled="optionSelected !== 0"
                        ><span class="input-group-addon"><i></i></span>
                    </div>
                </div>
            <div class="">
                <div class="form-group">
                    <label v-bind:class="{ 'text-muted': optionSelected !== 0 }" aria-label="text color" for="textcolor-form-element">
                        {{ translations.textColorLabel }}
                        <span :data-balloon="translations.colorDescription"
                              data-balloon-pos="right"
                              data-balloon-length="large"
                        ><i class="fa-light fa-circle-question cursor-pointer"></i>
                        </span>
                    </label>
                    <div class="input-group colorpicker-component">
                        <input
                            type="text"
                            name="textcolor"
                            class="form-control"
                            id="textcolor-form-element"
                            aria-label="text color input"
                            :disabled="optionSelected !== 0"
                        ><span class="input-group-addon"><i></i></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .color-picker-row {
        display: flex;
        gap: 24px;
    }

    .colorpicker-component:has(input:disabled) .input-group-addon {
        pointer-events: none;
        opacity: 0.5;
    }
</style>
